const riot = require('riot');

riot.tag2('page-workspaces-single', '<div class="s-full overflow-y-scroll bg-background_dark_primary text-white" ref="scrollContainer"> <div class="flex-fixed w-full mb50"> <div ref="projects" data-is="module-projects" is_loading="{isSetupLoading}"></div> </div> <div class="fixed b0 w-full" if="{!app.utils.isKeyboardOpen()}" ref="tabbar" data-is="module-tabbar" onclickcurrenttab="{onClickCurrentTab}"></div> </div>', 'page-workspaces-single,[data-is="page-workspaces-single"]{display:block}', '', function(opts) {
    this.preload = ({req, res}) => {
      if (spat.isBrowser && !app.auth.isSignIn()) {
        res.redirect(301, '/signin');
        return ;
      }
    };

    this.head = () => {
      if (app.store.workspace) {
        return {
          title: `${app.store.workspace.data.name} | ${spat.config.head.ogp.site_name}`,
        };
      }
    };

    this.on('show', async ({req, res}) => {

      this.update({ isSetupLoading: true });
      try {
        await app.store.setup(req.params);
      }
      catch (e) {
        app.utils.confirmReload(e);
        return ;
      }
      finally {
        this.update({ isSetupLoading: false });
      }
      spat.updateMeta();
    });

    this.onClickCurrentTab = () => {
      app.utils.scrollToTop(this.refs.scrollContainer);
    };
});